
import { formatMoney } from 'util.currency'

const searchInput = document.querySelector('.search__input-wrap .search__input');
let resultObserver;

// Function to handle fetching product data for the active product
function handleProductHoverOrActive() {
  const cloudSearchResult = document.querySelector('#cloud-search-results');
  if (!cloudSearchResult) return;

  const productsContainer = cloudSearchResult.querySelector('.block-products');
  if (!productsContainer) return;

  const activeProduct = productsContainer.querySelector('dd.active');
  if (!activeProduct) return;

  const productLink = activeProduct.querySelector('.name a')?.getAttribute('href');
  console.log("productLink", productLink);
  if (!productLink) return;

  const productHandle = productLink.split('/')[2];

  fetch(`/products/${productHandle}.js`)
    .then(response => {
      if (!response.ok) throw new Error('Product not found');
      return response.json();
    })
    .then(product => {
      if (product.tags.includes('decimal')) {
        const activeProductPrice = activeProduct.querySelector('.price');
        let stepSize = parseFloat(window.ShopifyTheme.settings.prDecimalStepSize);
        let updatedDecimalPrice = product.price / stepSize;
        let priUnit = window.ShopifyTheme.settings.priunit;

        // Use innerHTML because formatMoney can return <sup> tags
        activeProductPrice.innerHTML = formatMoney(
          updatedDecimalPrice,
          window.ShopifyTheme.settings.moneyFormat,
          false
        ) + " per " + priUnit;
      }
    })
    .catch(error => {
      console.error('Error fetching product:', error);
    });
}

// Function to observe search results
function observeSearchResults() {
  const cloudSearchResult = document.querySelector('#cloud-search-results');
  if (!cloudSearchResult) return;

  const productsContainer = cloudSearchResult.querySelector('.block-products');
  if (!productsContainer) return;

  // Hover listener for all products
  productsContainer.querySelectorAll('dt').forEach(dt => {
    dt.addEventListener('mouseenter', handleProductHoverOrActive);
  });

  // Update the active product immediately
  handleProductHoverOrActive();

  // Observe if the search results dynamically change
  if (resultObserver) resultObserver.disconnect();
  resultObserver = new MutationObserver(() => {
    productsContainer.querySelectorAll('dt').forEach(dt => {
      dt.addEventListener('mouseenter', handleProductHoverOrActive);
    });

    // Also update the active product when results change
    handleProductHoverOrActive();
  });
  resultObserver.observe(productsContainer, { childList: true, subtree: true });
}

// Keypress listener
searchInput.addEventListener('keypress', () => {
  // Wait a bit for search results to render
  console.log('key pressing');
  setTimeout(observeSearchResults, 100);
});
